export type ThemeId = "bankom" | "noc" | "polje" | "zetva" | "kapija" | "grafit";
export type Density = "compact" | "default" | "comfortable";
export type TextSize = "small" | "medium" | "large";
export type ReducedMotion = "system" | "on" | "off";

export type UiPreferences = {
  theme: ThemeId;
  followSystem: boolean;
  lightTheme: ThemeId;
  darkTheme: ThemeId;
  density: Density;
  textSize: TextSize;
  reducedMotion: ReducedMotion;
};

export const DEFAULT_PREFERENCES: UiPreferences = {
  theme: "bankom",
  followSystem: false,
  lightTheme: "bankom",
  darkTheme: "noc",
  density: "default",
  textSize: "medium",
  reducedMotion: "system",
};

export type ThemeMeta = {
  id: ThemeId;
  /** Proper noun, shown as-is in every language. */
  name: string;
  dark: boolean;
  /** The theme the topbar toggle switches to. */
  pair: ThemeId;
  /** Settings sent together with the theme when it is chosen. */
  onSelect?: Partial<Pick<UiPreferences, "density" | "textSize">>;
};

export const THEMES: Record<ThemeId, ThemeMeta> = {
  bankom: { id: "bankom", name: "Bankom", dark: false, pair: "noc" },
  noc: { id: "noc", name: "Noć", dark: true, pair: "bankom" },
  polje: { id: "polje", name: "Polje", dark: false, pair: "zetva" },
  zetva: { id: "zetva", name: "Žetva", dark: true, pair: "polje" },
  kapija: { id: "kapija", name: "Kapija", dark: false, pair: "grafit", onSelect: { density: "comfortable", textSize: "large" } },
  grafit: { id: "grafit", name: "Grafit", dark: true, pair: "kapija" },
};

export const THEME_ORDER: ThemeId[] = ["bankom", "noc", "polje", "zetva", "kapija", "grafit"];

export function isDark(id: ThemeId): boolean {
  return THEMES[id].dark;
}

export function effectiveTheme(p: UiPreferences, systemDark: boolean): ThemeId {
  if (!p.followSystem) return p.theme;
  return systemDark ? p.darkTheme : p.lightTheme;
}
